import { MapPin, Phone, Mail, QrCode } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-deep-blue/80 backdrop-blur-lg border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* 公司信息 */}
          <div>
            <h3 className="text-xl font-bold gradient-text mb-4">大连音智科技有限公司</h3>
            <div className="text-white/60 text-sm mb-4 space-y-1">
              <p>专注人工智能大模型技术</p>
              <p>赋能千行百业数字化转型</p>
            </div>
            <div className="space-y-2 text-white/60 text-sm">
              <div className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>辽宁省大连市品海街 57 号音智科技</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span>18500089321</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <span>sales@aiyinzhi.com</span>
              </div>
            </div>
          </div>

          {/* 快速链接 */}
          <div>
            <h4 className="text-white font-semibold mb-4">快速链接</h4>
            <ul className="space-y-2 text-white/60 text-sm">
              <li><a href="/" className="hover:text-tech-400 transition-colors">首页</a></li>
              <li><a href="/products" className="hover:text-tech-400 transition-colors">产品中心</a></li>
              <li><a href="/solutions" className="hover:text-tech-400 transition-colors">解决方案</a></li>
              <li><a href="/news" className="hover:text-tech-400 transition-colors">新闻动态</a></li>
              <li><a href="/about" className="hover:text-tech-400 transition-colors">关于我们</a></li>
            </ul>
          </div>

          {/* 产品系列 */}
          <div>
            <h4 className="text-white font-semibold mb-4">产品系列</h4>
            <ul className="space-y-2 text-white/60 text-sm">
              <li><a href="/products" className="hover:text-tech-400 transition-colors">静守™校园安全管控系统</a></li>
              <li><a href="/products" className="hover:text-tech-400 transition-colors">KKSP DataSummary 如易填报</a></li>
              <li><a href="/products" className="hover:text-tech-400 transition-colors">WiseStarup AI 中台套件</a></li>
            </ul>
          </div>

          {/* 微信公众号 */}
          <div>
            <h4 className="text-white font-semibold mb-4">关注公众号</h4>
            <div className="flex items-start space-x-3">
              <div className="bg-white p-2 rounded-lg">
                <img 
                  src="https://down.dingtalk.com/media/lQDPM4xFT3ei0FnNAVjNAViwbMqq2XAO98cJkWkvxJ98AA_344_344.jpg" 
                  alt="音智科技微信公众号" 
                  className="w-[150px] h-[150px] object-contain"
                />
              </div>
              <div>
                <div className="flex items-center space-x-2 text-white/60 text-sm mb-2">
                  <QrCode className="w-4 h-4" />
                  <span>微信公众号：音智</span>
                </div>
                <p className="text-white/40 text-xs">扫描二维码关注<br/>获取最新资讯</p>
              </div>
            </div>
          </div>
        </div>

        {/* 底部版权信息 */}
        <div className="pt-8 border-t border-white/10">
          <div className="text-center text-white/40 text-sm space-y-2">
            <p>&copy; 2026 大连音智科技有限公司 版权所有</p>
            <p>
              <a 
                href="https://beian.miit.gov.cn/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-tech-400 transition-colors"
              >
                辽 ICP 备 2022004180 号 -1
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
